module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-tablet.8ec3b948.jpg";